






























































































































import Vue from 'vue';
import firstCharsToUpperCase from '@/util/firstCharsToUpperCase';

export default Vue.extend({
  props: {
    optionsInit: Object,
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    date: '',
    dateConst: '',
    period: '',
    selectedSerie: {},
    selectedComprobante: 'INGRESO',
    selectedTipoComprobante: [{nombre: 'INGRESO'}, {nombre: 'EGRESO'}],
    formatoFecha: 'DD/MM/YYYY',
    formatoPeriodo: 'MM/YY',
    isSerieEmpty: true,
    openDialog: false,
    recibos: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Periodo', value: 'period' },
      { text: 'Propietario', value: 'propietario.nombre' },
      // { text: 'Recibo ID', value: 'id' },
      { text: 'Conceptos', value: 'items.length', sortable: false },
      { text: 'Subtotal', value: 'subtotal', sortable: false },
      { text: 'Monto Total', value: 'total', sortable: false },
    ],
    options: {},
    total: 0,
    precision: 2,
    menu1: false,
    menu2: false,
    daysLimit: 3000,
    min: '',
    max: '',
    series: [],
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    computedPeriodFormatted() {
      return this.$moment(this.period).format(this.formatoPeriodo);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    closeDialog() {
      this.openDialog = false;
    },
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.log('getSeriesList datos: %o', datos);
        const response = await this.$store.dispatch('getSeriesList', datos);
        console.log('getSeriesList response: %o', response);
        this.series = response;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
    },
    async GenerarBorradores() {
      if (!this.isSerieEmpty) {
        try {
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const borradores = this.recibos;
          const datos = {admin, condo, borradores};
          console.log('generarBorradores datos: %o', datos);
          for (const recibo of borradores) {
              if (this.selectedSerie.nombre !== null) {
                recibo.serie = this.selectedSerie.nombre;
              }
              recibo.tipoDeComprobante = this.selectedComprobante;
              recibo.fechaDeEmision = this.$moment(this.date).format();
              recibo.periodo = this.$moment(this.period).format();
              recibo.creationDateTime = this.$moment().format();
              recibo.creationUsername = this.$store.getters.getUsername;
            }
          const response = await this.$store.dispatch('generarBorradores', {datos});
          console.log('generarBorradores response: %o', response);
          this.$toast.success('La generación de Borradores fue Exitosa');
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.closeDialog();
        this.$emit('reload', {});
      } else {
        this.$toast.error('Seleccione una serie');
      }
    },
    periodo(item) {
      const fecha = this.$moment(item.fechaDeEmision).format('MMMM YYYY');
      return firstCharsToUpperCase(fecha);
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.date = this.$moment().format();
        this.period = this.date;
        this.dateConst = this.$moment().format();
        this.min = this.$moment().subtract(this.daysLimit, 'd').format('YYYY-MM-DD');
        this.max = this.$moment().add(this.daysLimit, 'd').format('YYYY-MM-DD');
        this.recibos = JSON.parse(JSON.stringify(this.recibosInit));
        this.options = JSON.parse(JSON.stringify(this.optionsInit));
        this.total = this.recibos.length;
        this.selectedSerie = {nombre: ''};
      } else {
        this.recibos = [];
      }
    },
    selectedSerie() {
      if (this.selectedSerie.nombre === '') {
        this.isSerieEmpty = true;
      } else {
        this.isSerieEmpty = false;
      }
    },
  },
});
